import { classes } from '../lib/divers';

/** Indicateur d'activité inline. */
export function Rouet({ grand = false }: { grand?: boolean }): JSX.Element {
  return (
    <span
      className={classes('gv-attente', grand && 'gv-attente--grand')}
      role="status"
      aria-label="Chargement en cours"
    />
  );
}

/** Bloc de chargement centré, utilisé pendant le premier chargement d'un écran. */
export function Chargement({ libelle = 'Chargement…' }: { libelle?: string }): JSX.Element {
  return (
    <div className="gv-vide">
      <Rouet grand />
      <p className="gv-corps-s">{libelle}</p>
    </div>
  );
}

/**
 * Squelette de tableau. Préféré à un rouet plein écran sur les listes : la structure reste
 * visible, l'œil ne se réinitialise pas à l'arrivée des données.
 */
export function SqueletteTableau({
  lignes = 6,
  colonnes = 5,
}: {
  lignes?: number;
  colonnes?: number;
}): JSX.Element {
  return (
    <div className="gv-carte__corps gv-pile gv-pile--serree" aria-hidden="true">
      {Array.from({ length: lignes }, (_, i) => (
        <div key={i} className="gv-ligne" style={{ gap: 'var(--gv-esp-4)' }}>
          {Array.from({ length: colonnes }, (_, j) => (
            <span
              key={j}
              className="gv-squelette"
              style={{ flex: j === 0 ? '2 1 0' : '1 1 0' }}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
